import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useAuth from 'src/context/AuthContext';
import { getAllSites } from 'src/redux/siteSlice';
import { isAdminUser } from 'src/utils/getInitials';

const useAdminSiteFilter = () => {
  const dispatch = useDispatch();
  const { getUser } = useAuth();
  const { allSites = [] } = useSelector((state) => state.sites);
  const [siteFilter, setSiteFilter] = useState('all');

  const isAdmin = isAdminUser(getUser);

  useEffect(() => {
    if (isAdmin && allSites.length === 0) {
      dispatch(getAllSites());
    }
  }, [allSites.length, dispatch, isAdmin]);

  const siteOptions = useMemo(
    () => [{ id: 'all', name: 'All Sites' }, ...allSites],
    [allSites]
  );

  return {
    isAdmin,
    siteFilter,
    setSiteFilter,
    siteOptions,
  };
};

export default useAdminSiteFilter;
